import { useEffect, useState } from "react";
import { api, money } from "../../lib/api";

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => { api("/admin/dashboard").then(setStats).catch(() => setStats({})); }, []);

  if (!stats) return <p className="text-muted font-bold">Counting stitches…</p>;

  const cards = [
    { label: "Paid revenue", value: money(stats.revenue_cents || 0), testid: "dashboard-revenue" },
    { label: "Orders paid", value: `${stats.orders_paid || 0} / ${stats.orders_total || 0}`, testid: "dashboard-orders" },
    { label: "Avg order", value: money(stats.avg_order_cents || 0), testid: "dashboard-avg-order" },
    { label: "New inquiries", value: stats.new_inquiries || 0, testid: "dashboard-inquiries" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-display font-semibold text-2xl">Dashboard</h1>
      <p className="text-muted text-sm font-semibold">Real numbers from real orders — nothing here is fabricated.</p>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
        {cards.map((c) => (
          <div key={c.label} className="bg-white rounded-3xl border border-candy-soft/70 p-5" data-testid={c.testid}>
            <p className="text-xs font-bold text-muted uppercase tracking-wide">{c.label}</p>
            <p className="font-display font-semibold text-2xl mt-1">{c.value}</p>
          </div>
        ))}
      </div>
      <div className="grid lg:grid-cols-2 gap-4 mt-6">
        <div className="bg-white rounded-3xl border border-candy-soft/70 p-5" data-testid="dashboard-low-stock">
          <h2 className="font-display font-semibold text-lg">Stock alerts</h2>
          {(stats.low_stock || []).length === 0 ? <p className="text-muted text-sm font-semibold mt-2">All stocked up.</p> : (
            <ul className="mt-3 space-y-2">
              {stats.low_stock.map((p) => (
                <li key={p.title} className="flex justify-between text-sm font-bold bg-candy-mist rounded-xl px-3 py-2"><span>{p.title}</span><span className="text-candy-deep">{p.stock} left</span></li>
              ))}
            </ul>
          )}
        </div>
        <div className="bg-white rounded-3xl border border-candy-soft/70 p-5" data-testid="dashboard-custom-pipeline">
          <h2 className="font-display font-semibold text-lg">Custom order pipeline</h2>
          {Object.keys(stats.custom_pipeline || {}).length === 0 ? <p className="text-muted text-sm font-semibold mt-2">No custom requests yet.</p> : (
            <ul className="mt-3 space-y-2">
              {Object.entries(stats.custom_pipeline).map(([k, v]) => (
                <li key={k} className="flex justify-between text-sm font-bold bg-candy-mist rounded-xl px-3 py-2"><span className="capitalize">{k.replace(/_/g, " ")}</span><span className="text-candy-deep">{v}</span></li>
              ))}
            </ul>
          )}
        </div>
      </div>
      <div className="bg-white rounded-3xl border border-candy-soft/70 p-5 mt-6" data-testid="dashboard-recent-orders">
        <h2 className="font-display font-semibold text-lg">Recent orders</h2>
        {(stats.recent_orders || []).length === 0 ? <p className="text-muted text-sm font-semibold mt-2">No orders yet — share the shop!</p> : (
          <table className="w-full mt-3 text-sm">
            <thead><tr className="text-left text-muted font-bold text-xs uppercase"><th className="py-2">Order</th><th>Customer</th><th>Total</th><th>Status</th></tr></thead>
            <tbody>
              {stats.recent_orders.map((o) => (
                <tr key={o.id} className="border-t border-candy-soft/60 font-semibold" data-testid={`dashboard-order-${o.order_number}`}>
                  <td className="py-2 font-bold">{o.order_number}</td>
                  <td>{o.name}</td>
                  <td>{money(o.total_cents)}</td>
                  <td className="capitalize">{o.status.replace(/_/g, " ")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
